import { render, staticRenderFns } from "./AfterSalesForm.vue?vue&type=template&id=5c1b4ab8&scoped=true&"
import script from "./AfterSalesForm.vue?vue&type=script&lang=js&"
export * from "./AfterSalesForm.vue?vue&type=script&lang=js&"
import style0 from "./AfterSalesForm.vue?vue&type=style&index=0&id=5c1b4ab8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1b4ab8",
  null
  
)

export default component.exports